<template>
  <v-container fluid>
    <v-row justify="center">
      <!-- self link dialog show -->
      <v-card class="mx-4" v-if="dialogSelfShow">
        <v-card-title>{{ $t('connect.selfTitle') }}</v-card-title>
        <v-card-text>
          <v-row justify="center" class="pt-2">
            <a class="mx-1" :href="wlocation">{{ wlocation }}</a>
            <v-alert class="mt-4" type="info">
              <p>
                {{ $t('connect.self') }}
              </p>
            </v-alert>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" small to="/connections">OK</v-btn>
        </v-card-actions>
      </v-card>
      <!-- create contact -->
      <v-card v-if="dialogConnection" class="mx-4" light max-width="600">
        <v-card-title class="d-flex justify-space-between">
          <span>{{ $t('connect.title')}}</span>
          <v-icon @click="onCloseContact">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="px-4">
          <v-form v-model="valid">
            <v-container>
              <v-row justify="center" align="center">
                  <v-text-field
                    v-model="formData.pid"
                    :label="$t('app.att.pid')"
                    required
                    readonly
                    disabled
                  ></v-text-field>
                </v-row>
                <v-row>
                  <v-text-field
                    v-model="formData.nick"
                    :counter="100"
                    :rules="nickRules"
                    :label="$t('app.att.nick')"
                  ></v-text-field>
                </v-row>
                <v-row class="d-flex justify-center">
                  <v-btn-toggle
                    v-model="formData.selType"
                    mandatory
                  >
                    <v-btn rounded><v-icon>mdi-account-multiple</v-icon></v-btn>
                    <v-btn rounded><v-icon>mdi-clock-outline</v-icon></v-btn>
                    <v-btn rounded><v-icon>mdi-account-off-outline</v-icon></v-btn>
                  </v-btn-toggle>
                  <v-icon class="ml-4" color="grey" @click="$router.push({ path: '/help/3'})">mdi-information</v-icon>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pl-4 pr-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" small @click="onCreateContact" :disabled="formData.pid === ''">{{ $t('app.btn.create') }}</v-btn>
        </v-card-actions>
      </v-card>
      <!-- connect location -->
      <v-card v-if="dialogLocation" class="mx-4" light max-width="600">
        <v-card-title class="d-flex justify-space-between">
          <span>{{ $t('connect.titleLocation')}}</span>
          <v-icon @click="onCloseLocation">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="px-4">
          <v-form v-model="valid">
            <v-container>
              <v-row justify="center" align="center">
                <v-text-field
                  v-model="formData.lid"
                  :label="$t('app.att.lid')"
                  required
                  readonly
                  disabled
                ></v-text-field>
              </v-row>
              <v-row>
                <v-text-field
                  v-model="formData.name"
                  :counter="100"
                  :rules="nickRules"
                  :label="$t('locations.name')"
                ></v-text-field>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pl-4 pr-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" small @click="onCreateLocation" :disabled="formData.lid === ''">{{ $t('app.btn.create') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
//import { QrcodeStream, QrcodeCapture } from 'vue-qrcode-reader'

  export default {
    name: "Conect",
    components: {
    },
    props: {
      source: String,
    },
    data: () => ({
      dialog: 0,
      valid: false,
      formData: {
        pid: '',
        lid: '',
        nick: '',
        cor: '',
        type: 0,
        name: ''
      },
      nickRules: [
        v => v.length <= 100 || 'Maximálně 100 znaků',
      ]
    }),
    computed: {
        dialogSelfShow: function() {
          return this.dialog == 1
        },
        dialogConnection: function() {
          return this.dialog == 2
        },
        dialogLocation: function() {
          return this.dialog == 3
        }
    },
    async mounted() {
      if (this.$route.params.link) {
        if (this.$route.path.startsWith('/c')) {
          //connection
          var parts = this.$route.params.link.split(';')
          this.formData.cor = parts[0]
          this.formData.pid = parts[1]
          if (parts.length === 3) {
            this.formData.nick = parts[2]
          }
          await this.$store.dispatch('waitOnInit')
          if (this.$store.state.data.pid === this.formData.pid) {
            this.dialog = 1
          }
          var exists = await this.$store.dispatch('connectionExistsAndResetTime', this.formData.pid)
          if (exists) {
            this.$emit('info', 'Kontakt již existuje. Čas setkání byl aktualizován.')
            this.$emit('toSynchronize')
            this.onCloseContact()
          } else {
            this.dialog = 2
          }
        } else {
          //connection
          var pparts = this.$route.params.link.split(';')
          this.formData.lid = pparts[0]
          if (pparts.length === 2) {
            this.formData.name = pparts[1]
          }
          await this.$store.dispatch('waitOnInit')
          var pexists = await this.$store.dispatch('locationExistsAndResetTime', this.formData.lid)
          if (pexists) {
            this.$emit('info', 'Místo již existuje. Čas návštěvy byl aktualizován.')
            this.$emit('toSynchronize')
            this.onCloseLocation()
          } else {
            this.dialog = 3
          }
        }
      }
    },
    methods: {
      reset() {
        this.valid = false
        this.formData.pid = ''
        this.formData.nick = ''
        this.formData.cor = ''
        this.formData.name = ''
      },
      async onCreateContact() {
          if (this.$store.state.data.pid === this.formData.pid) {
            this.$emit('info', this.$t('app.err.self'))
          } else {
            var res = await this.$store.dispatch('createConnection', this.formData)
            if (res) {
              this.onCloseContact()
              this.$emit('toSynchronize')
            } else {
              this.$emit('info', 'Vztah s tímto člověkem již v saznamu existuje.')
            }
          }
      },
      async onCreateLocation() {
          this.$store.dispatch('connectLocation', this.formData)
          this.onCloseLocation()
          this.$emit('toSynchronize')
      },
      onCloseContact() {
          this.reset()
          this.$router.push({path: "/connections"})
      },
      onCloseLocation() {
          this.reset()
          this.$router.push({path: "/locations"})
      },
      parseQRContent(content) {
          var s = content.substring(content.lastIndexOf('/') + 1)
          var parts = s.split(';')
          if (parts.length > 2) {
            return {cor: parts[0], pid: parts[1], nick: parts[2]}
          } else {
            return {cor: parts[0], pid: parts[0], nick: ''}
          }
      },
    }
  }
</script>
